import { Button, useToast } from '@chakra-ui/react';
import { ChangeEvent, useRef, useState } from 'react';
import { FiCamera } from 'react-icons/fi';
import { useQueryClient } from 'react-query';

import {
  FuelRecordKind,
  fuelErrorMessage,
  fuelReadingsService,
} from '../../../services/fuelReadingsService';
import { compressPhoto } from './compressPhoto';

// anexa a foto depois do lançamento (leitura do pc do posto, aferição ou nota
// sem foto). sem "capture": no celular dá para tirar na hora ou escolher da
// galeria; no pc abre a escolha de arquivo.
export function AttachPhotoButton({
  kind,
  id,
  label = 'Anexar foto',
}: {
  kind: FuelRecordKind;
  id: string;
  label?: string;
}) {
  const fileRef = useRef<HTMLInputElement>(null);
  const [sending, setSending] = useState(false);
  const queryClient = useQueryClient();
  const toast = useToast();

  const handleFile = async (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    // limpa o campo para poder escolher a mesma foto de novo
    if (fileRef.current) {
      fileRef.current.value = '';
    }

    if (!file) {
      return;
    }

    setSending(true);

    try {
      await fuelReadingsService.attachPhoto(
        kind,
        id,
        await compressPhoto(file),
      );
      await queryClient.invalidateQueries('fuel-readings');
      toast({ status: 'success', title: 'Foto anexada.', isClosable: true });
    } catch (err) {
      toast({
        status: 'error',
        title: fuelErrorMessage(err, 'Não foi possível anexar a foto.'),
        isClosable: true,
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        onChange={handleFile}
        style={{ display: 'none' }}
        aria-label={label}
      />
      <Button
        size="xs"
        variant="outline"
        colorScheme="orange"
        leftIcon={<FiCamera />}
        isLoading={sending}
        loadingText="Enviando..."
        onClick={() => fileRef.current?.click()}
      >
        {label}
      </Button>
    </>
  );
}
